class SizeError extends Error {
    constructor(message: string) {
        super(message);
        this.name = "SizeError";
    }
}

export { SizeError };